export default "__VITE_ASSET__g$awoYo___"